import apiClient from "../../config/apiClient";

export const downloadDocument = async (patient_id,doc_id) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.post(`/public/portal?url=patient/${patient_id}/documents/${doc_id}&method=GET&token=${token}`,
    {
      responseType: "blob", 
      headers: {
        Authorization: "Bearer " + token,
      },
  });
};

// 27503


// documents/30268